// @flow

import React from 'react';
import FAIcon from 'react-fontawesome';
import classnames from 'classnames';

type Props = {
  icon: string,
  className?: string,
  spin?: boolean,
};

const Icon = ({ icon, className, spin }: Props) => (
  <FAIcon spin={spin} name={icon} className={classnames(className)} />
);

export default Icon;
